module.exports = __webpack_public_path__ + "static/media/state_ipv_number.9c2df5c3.svg";